import { opaccSanitizePlugin } from '../opacc.static.js';

/** @module static */

/**
 * Temporäre Speicherung von HTML-Fragmenten als Storage-Objekt
 */
export class OpaccLocalstorage {

	/**
	 *
	 *
	 * @returns {*}
	 */
	getCurrentURI() {
		return `${window.location.pathname}${window.location.search}`;
	}

	/**
	 *
	 *
	 * @param {*} url
	 * @param {boolean} [replaceSelectors=true]
	 * @returns {*}
	 */
	getPersistentView( url, replaceSelectors = true ){
		let data = JSON.parse( this.getSessionStorage(url) );

		if( replaceSelectors ){
			for (let selector in data) {
				document.querySelector( selector ).outerHTML = opaccSanitizePlugin.sanitizeContent(data[selector]);
			}
		}

		return data;
	}

	/**
	 *
	 *
	 * @param {*} url
	 * @param {*} selectors
	 * @returns {*}
	 */
	setPersistentView( url, ...selectors ){
		let data = {};
		selectors.forEach(selector => {
			data[ selector ] = document.querySelector( selector ).outerHTML;
		});
		return this.setSessionStorage( url, JSON.stringify( data ) );
	}

	/**
	 *
	 *
	 * @param {*} url
	 * @returns {*}
	 */
	removeAllPersistentViews( url ){
		Object.keys(window.sessionStorage).forEach(item => {
			if (item !== url && (item.indexOf('take=async') != -1)) {
				this.removeSessionStorage(item);
			}
		});
		return;
	}

	/**
	 *
	 *
	 * @param {*} url
	 * @returns {*}
	 */
	removePersistentView( url ){
		return this.removeSessionStorage( url );
	}

	/**
	 *
	 *
	 * @param {*} key
	 * @returns {*}
	 */
	removeSessionStorage(key) {
		window.sessionStorage.removeItem(key);
		return true;
	}

	/**
	 *
	 *
	 * @param {*} key
	 * @param {*} data
	 * @returns {*}
	 */
	setSessionStorage(key, data) {
		window.sessionStorage.setItem(key, data);
		return true;
	}

	/**
	 *
	 *
	 * @param {*} key
	 * @returns {*}
	 */
	getSessionStorage( key ){
		return window.sessionStorage.getItem( key );
	}
}